const ItemTypes = {
  SOLUTION: "solution",
  OUT_OF_SCOPE_SOLUTION: "outOfScopeSolution",
  VALUE_MAP_CHALLENGE: "challenge",
  VALUE_MAP_KPI: "kpi"
};

export default ItemTypes;
